import deleteTeamsRoute from "../api/[orgId]/teams/delete.route";
import readTeamsRoute from "../api/[orgId]/teams/read.route";
import upsertTeamRoute from "../api/[orgId]/teams/upsert.route";
import { post } from "./lib";

export const readTeamsQueryKey = (orgId: string) => ["teams-read", { orgId }];

export const readTeams = (orgId: string) =>
  post<typeof readTeamsRoute>(`/api/${orgId}/teams/read`);

export const upsertTeam = (
  orgId: string,
  team: { id: string; name: string; description?: string; users: string[] }
) => post<typeof upsertTeamRoute>(`/api/${orgId}/teams/upsert`, team);

export const deleteTeam = (orgId: string, team_id: string) =>
  post<typeof deleteTeamsRoute>(`/api/${orgId}/teams/delete`, { team_id });
